var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{directives:[{name:"debounce",rawName:"v-debounce",value:(_vm.scroll),expression:"scroll"}],ref:"scrollbar",staticClass:"scroll-bar",attrs:{"src":require("../assets/images/home/scroll_bar.png"),"alt":"scroll_bar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }